<template>

  <div id="offCanvas1" class="off-canvas off-canvas-right wd-400">

    <div class="pd-20 ht-100p tx-13 gwas-elevation pos-relative">
      <div class="pd-y-10">
        <h3 class="tx-bold tx-spacing--2 tx-brand-02 mg-b-0">har<span class="tx-normal tx-primary">Vest</span></h3>
        <span class="tx-sans tx-9 tx-uppercase tx-semibold tx-spacing-1 tx-color-03">Search Filter</span>
      </div>

      <a href="" role="button" class="close pos-absolute t-15 r-15" aria-label="Close">
        <span aria-hidden="true"> <i data-feather="x"></i> </span>
      </a>

      <div class="pd-y-20 bd-t">
        <label class="tx-sans tx-10 tx-uppercase tx-bold tx-spacing-1 tx-color-02 mg-b-10">Search By Name, Address, or
          ...</label>
        <div class="input-group">
          <select v-model="search.filter" class="form-control" style="width: 10px; border-radius: 0;">
            <option value="first_name" selected>First Name</option>
            <option value="middle_name" selected>Middle Name</option>
            <option value="last_name" selected>Surame</option>
            <option value="address">Address</option>
            <option value="email">Email</option>
            <option value="post-code">Post Code</option>
          </select>
          <div class="search-form">
            <input v-model="search.parameter" type="search" class="form-control" placeholder="Search"
                   style="border-radius: 0;">
            <button v-on:click="searchEngine" class="btn" type="button"><i data-feather="search"></i></button>
          </div>
        </div>
      </div>


      <div class="divider-text">Personal Information</div>

      <div style="margin-top: -10px;">
        <label class="tx-sans tx-10 tx-uppercase tx-bold tx-spacing-1 tx-color-02 mg-b-10">Month of Birth</label>
        <select id="birthday_month" @change="searchEngine($event)" class="form-control select2-no-search">
          <option label="Choose Month of Birth"></option>
          <option value="1">January</option>
          <option value="2">February</option>
          <option value="3">March</option>
          <option value="4">April</option>
          <option value="5">May</option>
        </select>
      </div>


      <div class="mg-t-10">
        <label class="tx-sans tx-10 tx-uppercase tx-bold tx-spacing-1 tx-color-02 mg-b-10">Marital Status</label>
        <select id="marital_status" @change="searchEngine($event)" class="form-control select2-no-search">
          <option label="Choose Marital Status"></option>
          <option value="married">Married</option>
          <option value="single">Single</option>
          <option value="separated">Separated</option>
          <option value="divorced">Divorced</option>
          <option value="widowed">Widowed</option>
        </select>
      </div>


      <div class="mg-t-10">
        <label class="tx-sans tx-10 tx-uppercase tx-bold tx-spacing-1 tx-color-02 mg-b-10">Category</label>
        <select class="form-control select2-no-search">
          <option label="Filter by tags & categories"></option>
          <option value="Firefox">Youth</option>
          <option value="Chrome">Single</option>
          <option value="Chrome">Campus Fellowship</option>
          <option value="Chrome">Anglia Ruskin University</option>
          <option value="Chrome">Student</option>
        </select>
      </div>

      <div class="divider-text mg-t-30">Spiritual Information</div>

      <div style="margin-top: -10px;">
        <label class="tx-sans tx-10 tx-uppercase tx-bold tx-spacing-1 tx-color-02 mg-b-10">WOFBI Status</label>
        <select id="wofbi_status" @change="searchEngine($event)" class="form-control select2-no-search">
          <option label="Choose WOFBI Status"></option>
          <option value="yes">Yes</option>
          <option value="no">No</option>
        </select>
      </div>


      <div class="mg-t-10">
        <label class="tx-sans tx-10 tx-uppercase tx-bold tx-spacing-1 tx-color-02 mg-b-10">Water Baptism</label>
        <div class="alert alert-outline" role="alert" style="border: 1px solid #c0ccda; border-radius: 0.25rem;">
          <div class="d-flex">
            <div>
              <div class="form-check">
                <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1">
                <label class="form-check-label" for="flexRadioDefault1"> <b>No, </b> Not baptised with Water</label>
              </div>
              <div class="form-check">
                <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault2">
                <label class="form-check-label" for="flexRadioDefault2"> <b>Yes, </b> Already baptised with Water
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mg-t-10">
        <label class="tx-sans tx-10 tx-uppercase tx-bold tx-spacing-1 tx-color-02 mg-b-10">Service Unit</label>
        <select id="service_unit" @change="searchEngine($event)" class="form-control select2-no-search">
          <option label="Choose Service Unit"></option>
          <option value="Technical">Technical</option>
          <option value="Ushering">Ushering</option>
          <option value="Finance">Finance</option>
          <option value="Sanctuary">Sanctuary Keepers</option>
          <option value="Altar Minister">Altar Minister</option>
          <option value="Children Uni">Children Unit</option>
          <option value="yaf">Youth Alive Exco</option>
        </select>
      </div>

      <p class="mg-t-25">Royalty free means you just need to pay for rights to use the item once per end product. You
        don't need to pay additional or ongoing fees for each person who sees or uses it.</p>

      <a href="" class="btn btn-primary btn-block"> Filter </a>


    </div>
  </div><!-- off-canvas -->

  <div id="offCanvas2" class="off-canvas off-canvas-right wd-400">
    <div class="pd-20 ht-100p tx-13 gwas-elevation pos-relative">
      <div class="pd-y-10">
        <h3 class="tx-bold tx-spacing--2 tx-brand-02 mg-b-0">har<span class="tx-normal tx-primary">Vest</span></h3>
        <span class="tx-sans tx-9 tx-uppercase tx-semibold tx-spacing-1 tx-color-03"> Bulk Contact Upload Manager</span>
      </div>

      <a href="" role="button" class="close pos-absolute t-15 r-15" aria-label="Close">
        <span aria-hidden="true"> <i data-feather="x"></i> </span>
      </a>

      <div class="pd-y-20 bd-t">
        <h4 id="section8" class="mg-b-10">Bulk Upload</h4>
        <p class="mg-b-30">
          Ensure you upload a valid excel file with file extension .xlsx. The sample file below contains information
          about the data attributes and information plus optional and compulsory ones
        </p>

        <label class="tx-sans tx-10 tx-uppercase tx-bold tx-spacing-1 tx-color-02 mg-b-10">Click to upload xls
          document</label>

        <input class="form-control" type='file' ref="passportFile" accept='.xlsx,.xls,.csv'
               @change="uploadDataFile('XLS_UPLOAD_DATA')"/>
      </div>

      <div class="pd-y-10">
        <label class="tx-sans tx-uppercase tx-medium tx-10 tx-spacing-1 tx-color-03 mg-b-15">File Storage Status</label>

        <div class="media">
          <i data-feather="database" class="wd-30 ht-30"></i>
          <div class="media-body mg-l-5">
            <div class="tx-12 mg-b-4"> 10.2GB used of 50GB</div>
            <div class="progress ht-3 mg-b-20">
              <div class="progress-bar wd-20p" role="progressbar" aria-valuenow="15" aria-valuemin="0"
                   aria-valuemax="100"></div>
            </div>
          </div><!-- media-body -->
        </div><!-- media -->
        <p class="tx-12"> Maximum file storage is 2TB (2,000GB).
          <a style="cursor: grab; color: #0d4fba" v-on:click="downloadTemplate" target="_blank"> click the link to download template</a>
        </p>
      </div>

      <div v-if="uploadStatus === 'failed'" class="alert alert-solid alert-danger d-flex align-items-center mg-b-0"
           role="alert">
        <i data-feather="alert-circle" class="mg-r-10"></i> The data upload failed, notification will disappear in 5s
      </div>
      <div v-if="uploadStatus === 'success'" class="alert alert-solid alert-primary d-flex align-items-center mg-b-0"
           role="alert">
        <i data-feather="alert-circle" class="mg-r-10"></i> The data upload was successful, notification will disappear
        in 5s
      </div>

    </div>
  </div><!-- off-canvas -->

  <div id="offCanvas4" class="off-canvas off-canvas-right  wd-400">
    <div class="pd-20 ht-100p tx-13 gwas-elevation pos-relative">
      <div class="pd-y-10">
        <h3 class="tx-bold tx-spacing--2 tx-brand-02 mg-b-0">har<span class="tx-normal tx-primary">Vest</span></h3>
        <span
            class="tx-sans tx-9 tx-uppercase tx-semibold tx-spacing-1 tx-color-03"> Bulk SMS Notification Manager</span>
      </div>

      <a href="" role="button" class="close pos-absolute t-15 r-15" aria-label="Close">
        <span aria-hidden="true"> <i data-feather="x"></i> </span>
      </a>

      <div class="pd-y-20 bd-t">
        <h4 id="section8" class="mg-b-10">Bulk SMS</h4>
        <p class="mg-b-5">
          The sample file below contains information about the data attributes.
        </p>

        <div class="form-group">
          <label class="tx-10 tx-uppercase tx-medium tx-spacing-1 mg-b-5 tx-color-03">Recipient Names</label>
          <textarea class="form-control" rows="2" placeholder="Textarea" v-model="smsRecipientNames" disabled> </textarea>
        </div>

        <div class="form-group">
          <label class="tx-10 tx-uppercase tx-medium tx-spacing-1 mg-b-5 tx-color-03">Recipient Mobile</label>
          <textarea class="form-control" rows="2" placeholder="Textarea" v-model="smsMobile" disabled> </textarea>
        </div>

        <div class="form-group">
          <label class="tx-10 tx-uppercase tx-medium tx-spacing-1 mg-b-5 tx-color-03">Message:</label>
          <textarea class="form-control" rows="6" placeholder="Textarea" v-model="smsMessage"> </textarea>
        </div>

        <label class="tx-10 tx-uppercase tx-medium tx-spacing-1 mg-b-5 tx-color-03">This is what your message will look like:</label>
        <div class="bd bg-gray-100 pd-y-5 pd-x-10 pd-sm-x-10">
          <p class="tx-13 tx-color-03"> {{fullSMS}} </p>
        </div>

        <span class="tx-13 tx-color-03"> {{fullSMS.length}} characters / {{Math.ceil(fullSMS.length / 160)}} page SMS  </span>


        <div class="modal-footer pd-x-0 pd-y-15">
          <button v-on:click="sendSMS" type="button" class="btn btn-primary mg-b-5 mg-sm-b-0">Send SMS
          </button>
          <button type="button" ref="closeModalBtn" class="btn btn-secondary mg-sm-l-5" data-bs-dismiss="modal">Cancel
          </button>
        </div>


      </div>

<!--      <div v-if="uploadStatus === 'failed'" class="alert alert-solid alert-danger d-flex align-items-center mg-b-0"-->
<!--           role="alert">-->
<!--        <i data-feather="alert-circle" class="mg-r-10"></i> The data upload failed, notification will disappear in 5s-->
<!--      </div>-->
<!--      <div v-if="uploadStatus === 'success'" class="alert alert-solid alert-primary d-flex align-items-center mg-b-0"-->
<!--           role="alert">-->
<!--        <i data-feather="alert-circle" class="mg-r-10"></i> The data upload was successful, notification will disappear-->
<!--        in 5s-->
<!--      </div>-->

    </div>
  </div><!-- off-canvas -->

  <ContactForm/>

  <SideBarAsideFix/>

  <div class="content ht-100v pd-0">
    <div class="content-header">
      <div class="content-search">
        <i data-feather="search"></i>
        <input type="search" class="form-control" placeholder="Search...">
      </div>
      <nav class="nav">
        <a href="" class="nav-link"><i data-feather="help-circle"></i></a>
        <a href="" class="nav-link"><i data-feather="grid"></i></a>
        <a href="" class="nav-link"><i data-feather="align-left"></i></a>
      </nav>
    </div><!-- content-header -->

    <div class="content-body">
      <div class="container pd-x-0">
        <div class="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
          <div>
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb breadcrumb-style1 mg-b-10">
                <li class="breadcrumb-item"><a href="#">Dashboard</a></li>
                <li class="breadcrumb-item active" aria-current="page"> Contact Manager</li>
              </ol>
            </nav>
            <h4 class="mg-b-0 tx-spacing--1 d-none">Welcome to Dashboard</h4>
          </div>
          <div class=" d-md-block">


            <div class="dropdown" style="display: inline;">
              <button class="btn dropdown-toggle btn-sm pd-x-15 btn-outline-success btn-uppercase mg-l-5" data-bs-toggle="dropdown">
                More Actions
              </button>
              <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">

                <button class="dropdown-item" v-on:click="exportData"> <i data-feather="download" class="wd-10 mg-r-5"></i> Export </button>

                <button class="dropdown-item off-canvas-menu" href="#offCanvas2" > <i data-feather="upload" class="wd-10 mg-r-5"></i> Upload </button>

                <button class="dropdown-item off-canvas-menu" href="#offCanvas4" v-on:click="populateSMSForm">
                  <i data-feather="inbox" class="wd-10 mg-r-5"></i> Send SMS</button>
              </div>
            </div>

            <button href="#offCanvas1" class="off-canvas-menu  btn btn-sm pd-x-15 btn-white btn-uppercase mg-l-5">
              <i data-feather="filter" class="wd-10 mg-r-5"></i> filter
            </button>

            <button href="#offCanvas3" class="off-canvas-menu btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5"><i
                data-feather="user-plus" class="wd-10 mg-r-5"></i> Add new
            </button>





          </div>
        </div>


        <div class="row row-xs">
          <div class="col mg-t-0">
            <div class="contact-grid">

              <template v-for="contact in contacts" :key="contact.id" :id="'row-'+contact.id">
              <div class="contact-card">
                <div class="card-header-row">
                  <div class="card-identity">
                    <div class="avatar avatar-online">
                      <img v-if="contact.profile_picture" :src="`${profileFolder}/${contact.profile_picture}`" class="rounded-circle" alt="">
                      <span v-else class="avatar-initial rounded-circle bg-gray-600">{{ contact.first_name?.charAt(0) }}</span>
                    </div>
                    <div>
                      <p class="card-name">
                        <a :href="`/users/${contact.id}`" class="text-black">
                          <span v-if="(contact?.first_name + contact?.middle_name + contact?.last_name).length<24">
                            {{ contact?.first_name }} {{ contact?.middle_name }} {{ contact?.last_name }}
                          </span>
                          <span v-else>
                            {{(contact?.first_name + ' ' + contact?.middle_name + ' ' + contact?.last_name)?.substring(0, 22) + "..." }}
                          </span>
                        </a>
                      </p>
                      <p class="card-role">
                        <span v-if="(contact.contact_address).length<24">{{ contact.contact_address }}</span>
                        <span v-else>{{ (contact.contact_address)?.substring(0, 22) + "..." }}</span>
                      </p>
                    </div>
                  </div>
                  <button class="menu-btn"><i class="fas fa-ellipsis-v"></i></button>
                </div>
                <div class="card-info">
                  <div class="info-row">
                    <i class="far fa-envelope"></i>
                    <span v-if="(contact?.email)?.length<30">{{ contact?.email }}</span>
                    <span v-else>{{ (contact?.email)?.substring(0, 22) + "..." }}</span>
                  </div>
                  <div class="info-row"><i class="fas fa-phone"></i> {{ contact.phone_number }} </div>
                  <div class="info-row"><i class="fas fa-birthday-cake"></i> {{ this.months[contact.birthday_month] }} {{ contact.birthday_day }} </div>
                </div>
                <div class="card-tags">
                  <span class="tag tag-collab">{{ contact.service_unit }}</span>
                  <span class="tag tag-rated"> {{ contact.gender }} </span>
                </div>
                <div class="card-footer-row">
                  <div class="footer-actions">
                    <a href="#"><i class="far fa-envelope"></i></a>
                    <a href="#"><i class="fas fa-phone"></i></a>
                    <a href="#"><i class="far fa-comment"></i></a>
                    <a href="#"><i class="fab fa-slack"></i></a>
                  </div>
                  <div class="footer-avatar">CT</div>
                  <div class="footer-avatar bg-primary">RH</div>
                </div>
              </div>
              </template>

            </div><!-- card -->
          </div><!-- col -->
        </div>



        <div class="row row-xs">
          <div class="mg-l-20 mg-b-15 mg-t-20">

            <ul class="pagination pagination-circle mg-b-0">
              <li v-if="pagination.currentPage === 1" class="page-item disabled">
                <a class="page-link page-link-icon"> <i data-feather="chevron-left"></i> </a>
              </li>

              <li v-else class="page-item">
                <router-link to="?page=1" class="page-link page-link-icon"><i data-feather="checvron-left"></i>
                </router-link>
              </li>

              <li v-for="page in pagination.pageArr" :key="page" class="page-item" :class="{ active: page === pagination.currentPage }">
                <router-link :to="`?page=${page}`" class="page-link"> {{ page }}</router-link>
              </li>

              <li v-if="pagination.currentPage === pagination.totalPages" class="page-item disabled">
                <a class="page-link"><i data-feather="chevron-right"></i></a>
              </li>

              <li v-else class="page-item">
                <router-link :to="`?page=${pagination.totalPages}`" class="page-link"><i
                    data-feather="chevron-right"></i></router-link>
              </li>
            </ul><!-- .pagination -->


            <div style="float: right; margin-right: 15px; margin-top: -40px;">
              <span class=" pd-x-15 mg-l-5"> Showing {{ pagination.report }} </span>
              <select @change="updateDataSize($event)"
                      class="form-control select2-no-search btn btn-sm pd-x-15 btn-white"
                      style="width: 60px;">
                <option v-for="pageSize in pagination.pageSizes" :key="pageSize" :value="pageSize"
                        :selected="pageSize === pagination.selectedSize">
                  {{ pageSize }}
                </option>
              </select>

            </div>

          </div>
        </div><!-- row -->



      </div><!-- container -->
    </div>
  </div>

</template>

<script>

import footerScriptMixin from "@/mixins/footer-script";
import SideBarAsideFix from "../components/SideBarAsideFix.vue";
import serviceMixin from "@/mixins/contact-service";
import paginationMixin from "@/mixins/data-table";
import ContactForm from "../contact/ContactForm.vue";

export default {
  name: "User",
  components: {ContactForm, SideBarAsideFix},
  mixins: [footerScriptMixin, paginationMixin, serviceMixin],
  props: {
    page: {type: String},
    first_name: {type: String},
    middle_name: {type: String},
    last_name: {type: String},
    email: {type: String},
    birthday_month: {type: String},
    marital_status: {type: String},
    wofbi_status: {type: String},
    water_baptism: {type: String},
    service_unit: {type: String},
    attendance_month: {type: String},
    attendance_year: {type: String},
    sort: {type: String},
    size: {type: String}
  },
  watch: {
    page: function () {
      this.loadData();
    },
    first_name: function () {
      this.loadData();
    },
    middle_name: function () {
      this.loadData();
    },
    last_name: function () {
      this.loadData();
    },
    email: function () {
      this.loadData();
    },
    birthday_month: function () {
      this.loadData();
    },
    marital_status: function () {
      this.loadData();
    },
    wofbi_status: function () {
      this.loadData();
    },
    water_baptism: function () {
      this.loadData();
    },
    service_unit: function () {
      this.loadData();
    },
    attendance_month: function () {
      this.loadData();
    },
    attendance_year: function () {
      this.loadData();
    },
    sort: function () {
      this.loadData();
    },
    size: function () {
      this.loadData();
    },
    smsMessage: function () {
      //whenever smsMessage changes
      this.fullSMS = `Hi ${this.firstContactName} ${this.smsMessage}`
    },

  },
  // watch: {
  //   $store: {
  //     handler(value, oldValue) {
  //       this.contacts = this.$store.state.contact_list;
  //       this.propsPage = this.$store.state.page;
  //       console.log(value.state);
  //       console.log(oldValue?.name);
  //     },
  //     deep: true,
  //     immediate: true,
  //   }
  // },
  data() {
    return {
      contacts: [],

      smsMobile: '',
      smsRecipientNames: '',
      firstContactName: '',
      smsMessage: '',
      fullSMS: '',
      charCount: '',
      messagePage: '',

      propsPage: 1,
      pagination: {
        totalPages: 0,
        page: 0,
        currentPage: 0,
        report: '',
        pageArr: [],
        pageSizes: [],
        selectedSize: 10
      },
      search: {
        parameter: '',
        filter: 'first_name'
      },
      isAdmin: '',
      userDetail: '',
      uploadStatus: '',
      months: ['', 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
    }
  },
  created() {
    //alert(this.domain)
    this.loadData();
    this.footerScript();
    this.offCanvasScript();
    this.asideBarScript();
  },
  methods: {
    async loadData() {
      let userData = {
        page: this.page,
        first_name: this.first_name,
        middle_name: this.middle_name,
        last_name: this.last_name,
        email: this.email,
        birthday_month: this.birthday_month,
        marital_status: this.marital_status,
        wofbi_status: this.wofbi_status,
        water_baptism: this.water_baptism,
        service_unit: this.service_unit,
        size: this.size,
        sort: this.sort
      };
      localStorage.setItem("userData", JSON.stringify(userData));

      let url = await this.buildQueryParam(this.page, this.first_name, this.middle_name, this.last_name, this.email,
          this.birthday_month, this.marital_status, this.wofbi_status, this.water_baptism, this.service_unit,
          this.attendance_month, this.attendance_year, this.size, this.sort);

      let result = await this.getContacts(url);

      if (result.data) {
        this.pagination = this.mixinDatatableDefaults(result.data.page);
        this.contacts = this.$store.state.contact_list;
        //this.loadDetails(this.contacts[0].id);
      } else {
        this.contacts = [];
        this.pagination = {};
      }
    },
    updateDataSize(event) {
      this.footerScriptChangeBatchSize(event);
      this.loadData();
    },
    async loadDetails(personId) {
      this.findContactsById(personId);
    },
    async searchEngine(event) {
      let queryObject = {};
      // Get current url parameters /^\s*$/.test(str)
      let updateQuery = this.$router.currentRoute.value.query;
      Object.keys(updateQuery).forEach(key => {
        if (!(/^\s*$/.test(queryObject[key]))) {
          queryObject[key] = updateQuery[key];
        }
      })

      // Get search parameter
      let param = this.search.parameter.trim();
      let filter = this.search.filter;
      if (!(/^\s*$/.test(param))) {
        queryObject[filter] = param;
      }

      // Capture drop down box events
      if (event.target.id === "birthday_month") {
        queryObject.birthday_month = event.target.value;
      }

      if (event.target.id === "marital_status") {
        queryObject.marital_status = event.target.value;
      }

      if (event.target.id === "wofbi_status") {
        queryObject.wofbi_status = event.target.value;
      }

      if (event.target.id === "water_baptism") {
        queryObject.water_baptism = event.target.value;
      }

      if (event.target.id === "service_unit") {
        queryObject.service_unit = event.target.value;
      }

      this.$router.push({path: this.$router.currentRoute.value.path, query: queryObject});
    },

    async uploadDataFile(fileType) {
      if (confirm("Do you really want to upload the file?")) {
        let formData = new FormData();
        formData.append('fileType', fileType);
        formData.append('description', 'National ID');
        formData.append('file', this.$refs.passportFile.files[0]);
        try {
          await this.$axios.post(`${this.appServer}/contacts/uploads`, formData, {
            headers: {'Content-Type': 'multipart/form-data'}
          });
          this.uploadStatus = "success";
          await this.loadData();
        } catch (error) {
          console.error(error);
          if (error.response) {
            alert(error.response.data.errorMessage);
          }
          this.uploadStatus = "failed";
        }
      } else {
        this.uploadStatus = "failed";
      }
      await new Promise(resolve => setTimeout(resolve, 5000));
      this.uploadStatus = "";
    },

    async populateSMSForm() {
      this.smsMobile = this.contacts.map(contact => '+44' + contact.phone_number).join(",");
      this.smsRecipientNames = this.contacts.map(contact => contact.first_name + ' ' + contact.last_name).join(", ");
      if (this.contacts.length > 0) {
        const first = this.contacts[0];
        this.firstContactName = `${first.first_name} ${first.last_name}`;
      }
    },

    async sendSMS() {
      const query = JSON.parse(localStorage.getItem("userData"));
      let queryParam = await this.buildQueryParam(query.page, query.first_name, query.middle_name, query.last_name, query.email,
          query.birthday_month, query.marital_status, query.wofbi_status, query.water_baptism, query.service_unit, query.size, query.sort);

      await this.sendSmsToContacts(queryParam, this.smsMessage)
      console.log(queryParam);
    },

    async exportData() {
      const query = JSON.parse(localStorage.getItem("userData"));
      let queryParam = await this.buildQueryParam(query.page, query.first_name, query.middle_name, query.last_name, query.email,
          query.birthday_month, query.marital_status, query.wofbi_status, query.water_baptism, query.service_unit, query.size, query.sort);

      await this.exportContacts(queryParam)
      console.log(queryParam);
    },

    async downloadTemplate() {
      await this.downloadContactsTemplate();
    }

  }
}
</script>
<style scoped>
@import '../../assets/css/dashforge.dashboard.css';
@import '../../assets/lib/remixicon/fonts/remixicon.css';
@import '../../assets/lib/select2/css/select2.min.css';

/* Grid */
.contact-grid { display:grid; grid-template-columns:repeat(4,1fr); gap:13px; }
@media(max-width:1200px){ .contact-grid{ grid-template-columns:repeat(2,1fr); } }
@media(max-width:640px) { .contact-grid{ grid-template-columns:1fr; } }

/* Card */
.contact-card {
  background:#fff; border-radius:8px; padding:18px 18px 14px;
  box-shadow:0 1px 3px rgba(0,0,0,.06); border:1px solid #e5e9f2;
  display:flex; flex-direction:column; gap:10px; position:relative;
}
.card-header-row { display:flex; align-items:flex-start; justify-content:space-between; }
.card-identity   { display:flex; align-items:center; gap:12px; }
.avatar-placeholder {
  width:48px; height:48px; border-radius:50%;
  display:flex; align-items:center; justify-content:center;
  color:#fff; font-weight:700; font-size:15px; flex-shrink:0;
}
.card-name { font-size:14px; font-weight:700; color:#1c273c; margin:0; line-height:1.3; }
.card-role { font-size:12px; color:#8392a5; margin:2px 0 0; }

/* Dropdown trigger */
.menu-wrap { position:relative; }
.menu-btn {
  background:none; border:none; cursor:pointer; color:#8392a5;
  font-size:16px; padding:2px 6px; line-height:1; border-radius:4px; transition:background .15s;
}
.menu-btn:hover { background:#f3f5f9; color:#1c273c; }

/* Dropdown */
.dropdown-menu-custom {
  display:none; position:absolute; right:0; top:calc(100% + 4px);
  background:#fff; border:1px solid #e5e9f2; border-radius:6px;
  box-shadow:0 4px 16px rgba(0,0,0,.10); min-width:145px; z-index:200; overflow:hidden;
}
.dropdown-menu-custom.show { display:block; animation:ddFade .12s ease; }
@keyframes ddFade { from{opacity:0;transform:translateY(-4px)} to{opacity:1;transform:translateY(0)} }
.dropdown-menu-custom a {
  display:flex; align-items:center; gap:8px; padding:9px 14px;
  font-size:13px; color:#596882; text-decoration:none; transition:background .12s;
}
.dropdown-menu-custom a:hover   { background:#f3f5f9; color:#1c273c; }
.dropdown-menu-custom a i       { width:14px; text-align:center; font-size:12px; }
.dropdown-menu-custom a.danger  { color:#dc3545; }
.dropdown-menu-custom a.danger:hover { background:#fff5f5; }

/* Info rows */
.card-info  { display:flex; flex-direction:column; gap:6px; }
.info-row   { display:flex; align-items:center; gap:8px; font-size:12.5px; color:#596882; }
.info-row i { width:14px; text-align:center; color:#8392a5; font-size:12px; }

/* Tags */
.card-tags { display:flex; gap:6px; flex-wrap:wrap; }
.tag        { font-size:11px; font-weight:600; padding:3px 10px; border-radius:16px; border:1.5px solid; }
.tag-collab { color:#10b981; border-color:#10b981; background:rgba(16,185,129,.06); }
.tag-rated  { color:#f59e0b; border-color:#f59e0b; background:rgba(245,158,11,.06); }

/* Footer */
.card-footer-row { display:flex; align-items:center; justify-content:space-between; border-top:1px solid #f0f3f7; padding-top:12px; margin-top:2px; }
.footer-actions  { display:flex; gap:14px; }
.footer-actions a { color:#8392a5; font-size:14px; text-decoration:none; transition:color .15s; }
.footer-actions a:hover { color:#5b73e8; }
.footer-avatar {
  width:28px; height:28px; border-radius:50%;
  display:flex; align-items:center; justify-content:center;
  color:#fff; font-size:11px; font-weight:700;
}
</style>




<!--<div class="row row-xs" style="display: block;">-->

<!--<div class="col mg-t-20">-->
<!--  <div class="card-dashboard-table card gwas-elevation table-responsive">-->

<!--    <table class="table table-bordered table-hover">-->
<!--      <thead>-->
<!--      <tr>-->
<!--        <th>&nbsp;</th>-->
<!--        <th colspan="3">Personal Details</th>-->
<!--        <th colspan="3">Contact Details</th>-->
<!--      </tr>-->
<!--      <tr>-->
<!--        <th>Full Name</th>-->
<!--        <th>Birthday</th>-->
<!--        <th>Gender</th>-->
<!--        <th>Service Unit</th>-->
<!--        <th>Home Address</th>-->
<!--        <th>Email Address</th>-->
<!--        <th>Mobile Phone</th>-->
<!--      </tr>-->
<!--      </thead>-->
<!--      <tbody>-->
<!--      <template v-for="(contact) in contacts" :key="contact.id" :id="'row-'+contact.id">-->
<!--        <tr>-->
<!--          <td data-label="Full Name"><a :href="`/users/${contact.id}`">-->
<!--                      <span v-if="(contact?.first_name + contact?.middle_name + contact?.last_name).length<24">-->
<!--                      {{ contact?.first_name }} {{ contact?.middle_name }} {{ contact?.last_name }}-->
<!--                    </span>-->
<!--            <span v-else>-->
<!--                      {{(contact?.first_name + ' ' + contact?.middle_name + ' ' + contact?.last_name)?.substring(0, 22) + "..." }}-->
<!--                    </span>-->
<!--          </a></td>-->
<!--          <td data-label="Birthday"> {{ this.months[contact.birthday_month] }} {{ contact.birthday_day }}</td>-->
<!--          <td data-label="Gender"> {{ contact.gender }}</td>-->
<!--          <td data-label="Service Unit"> {{ contact.service_unit }}</td>-->

<!--          <td data-label="Home Address">-->
<!--            <span v-if="(contact.contact_address).length<24">{{ contact.contact_address }}</span>-->
<!--            <span v-else>{{ (contact.contact_address)?.substring(0, 22) + "..." }}</span>-->
<!--          </td>-->

<!--          <td data-label="Email Address">-->
<!--            <span v-if="(contact?.email)?.length<30">{{ contact?.email }}</span>-->
<!--            <span v-else>{{ (contact?.email)?.substring(0, 22) + "..." }}</span>-->
<!--          </td>-->

<!--          <td data-label="Mobile Phone"> {{ contact.phone_number }}</td>-->
<!--        </tr>-->
<!--      </template>-->
<!--      </tbody>-->
<!--    </table>-->

<!--    <div class="mg-l-20 mg-b-15">-->

<!--      <ul class="pagination pagination-circle mg-b-0">-->
<!--        <li v-if="pagination.currentPage === 1" class="page-item disabled">-->
<!--          <a class="page-link page-link-icon"> <i data-feather="chevron-left"></i> </a>-->
<!--        </li>-->

<!--        <li v-else class="page-item">-->
<!--          <router-link to="?page=1" class="page-link page-link-icon"><i data-feather="chevron-left"></i>-->
<!--          </router-link>-->
<!--        </li>-->

<!--        <li v-for="page in pagination.pageArr" :key="page" class="page-item"-->
<!--            :class="{ active: page === pagination.currentPage }">-->
<!--          <router-link :to="`?page=${page}`" class="page-link"> {{ page }}</router-link>-->
<!--        </li>-->

<!--        <li v-if="pagination.currentPage === pagination.totalPages" class="page-item disabled"><a-->
<!--            class="page-link"><i data-feather="chevron-right"></i></a></li>-->

<!--        <li v-else class="page-item">-->
<!--          <router-link :to="`?page=${pagination.totalPages}`" class="page-link"><i-->
<!--              data-feather="chevron-right"></i></router-link>-->
<!--        </li>-->
<!--      </ul>&lt;!&ndash; .pagination &ndash;&gt;-->


<!--      <div style="float: right; margin-right: 15px; margin-top: -40px;">-->
<!--        <span class=" pd-x-15 mg-l-5"> Showing {{ pagination.report }} </span>-->
<!--        <select @change="updateDataSize($event)"-->
<!--                class="form-control select2-no-search btn btn-sm pd-x-15 btn-white"-->
<!--                style="width: 60px;">-->
<!--          <option v-for="pageSize in pagination.pageSizes" :key="pageSize" :value="pageSize"-->
<!--                  :selected="pageSize === pagination.selectedSize">-->
<!--            {{ pageSize }}-->
<!--          </option>-->
<!--        </select>-->

<!--      </div>-->


<!--    </div>-->

<!--  </div>&lt;!&ndash; card &ndash;&gt;-->
<!--</div>&lt;!&ndash; col &ndash;&gt;-->
<!--</div>&lt;!&ndash; row &ndash;&gt;-->
